export default __webpack_public_path__ + "98d70fddc5a2f465740e00cac8bc759e.png";